import React, { useEffect, useState } from "react";
import "./QrModalStyles.scss";
import Button from "../Button";

export default function QrModal({ setIsOpen }: any) {
    return (
        <>
            <div
                className="success_modal_containerCookies"
                onClick={(e) => {
                    e.stopPropagation();
                    setIsOpen(false);
                }}
            >
                <div
                    style={{
                        position: "fixed",
                        bottom: 0,
                        top: 0,
                        left: 0,
                        right: 0,
                        margin: "auto",
                        background: "#fff",
                        padding: 20,
                        width: "90%",
                        maxWidth: 450,
                        height: 440,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        borderRadius: 10,
                        overflow: "hidden",
                    }}
                >
                    <img src="/assets/qr/qr.png" alt="qr" />

                    <img
                        src="./assets/home/car_04.svg"
                        title="Compras online con atención personalizada."
                        alt="Compras online con atención personalizada."
                        className="car_4 position-absolute d-none d-md-block"
                        loading="lazy"
                        style={{ zIndex: -1, bottom: -30, right: -60 }}
                        decoding="async"
                    />
                </div>
            </div>
        </>
    );
}
